module.exports = __webpack_public_path__ + "img/santa-fe.e8729c42.webp";